import React from 'react';

/**
 * Abstracts away the gross-ness of using the raw HTML supplied by the Vistaprint pricing service
 */
export default function Price(props) {
    const {
        priceHTML,
        style,
    } = props;

    return (
        <span style={style} dangerouslySetInnerHTML={{ __html: priceHTML }}></span>
    );
}



// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/Price.js